import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Evaluator Config',
  attributeName: 'evaluatorConfig',
  fields: [
    {
      attributeName: 'simpleLoadControl',
      helpText: ' A flag to establish whether a simplified load control is used. Typically, this will be disabled (set to false). Consider deprecating in future versions.',
      type: FormInputTypes.CHECKBOX,
      label: 'Simple load control',
      placeholder: 'Input a bandwidtch fraction...',
      default: false,
    },
    {
      attributeName: 'bandwidthFraction',
      helpText: ' The fraction of the available bandwidth that the evaluator should consider available for use. Setting to a value less than 1 is recommended to account for inaccuracies in the bandwidth estimator (0-1).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Bandwidth Fraction',
      placeholder: 'Input a bandwidtch fraction...',
      default: 0,
    },
    {
      attributeName: 'allowExceedsCapabilitiesInAdaptiveVideo',
      helpText: 'Allow Exceeds Capabilities In Adaptative Video.',
      type: FormInputTypes.CHECKBOX,
      label: 'Allow Exceeds capabilities In Adaptative Video',
      default: true,
    },
    {
      attributeName: 'maxInitialBitrate',
      helpText: 'The initial bitrate the player will consider while it doesnt have any information about the actual network bandwidth (bps). The current recommendation is to pick a value matching the likeliest maximum bitrate in the experiences included in the content list.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Max Initial Bitrate',
      placeholder: 'Input a max initial bitrate...',
      default: 0,
    },
    {
      attributeName: 'overheadOffset',
      helpText: ' Overhead after segment download in milliseconds. Increasing it will increase viewport change time.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Overhead Offset',
      placeholder: 'Input the overhead offset...',
      default: 0,
    },
    {
      attributeName: 'bandwidthModulationSlopeStart',
      helpText: 'Start of the modulation slope in milliseconds. If the available buffer is shorter than this, the available bandwidth will be set to zero',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Bandwidth Modulation Slope Start',
      placeholder: 'Input a bandwidth modulation slope start...',
      default: 0,
    },
    {
      attributeName: 'bandwidthModulationSlopeEnd',
      helpText: 'End of the modulation slope in milliseconds. If the available buffer is longer than this, the available bandwidth will be set to whatever the bandwidth monitor reports multiplied by bandwidthFraction. If the available buffer is between bandwidthModulationSlopeStartUs and bandwidthModulationSlopeEndUs the bandwidth will be a function between zero and whatever the bandwidth monitor reports multiplied by bandwidthFraction.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Bandwidth Modulation Slope End',
      placeholder: 'Input a bandwidth modulation slope end...',
      default: 0,
    },
    {
      attributeName: 'bandwidthModulationBufferingFactor',
      helpText: 'If the player runs into buffering issues it will become more conservative (should be >1).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Bandwidth Modulation Buffering Factor',
      placeholder: 'Input a bandwidth modulation buffering factor...',
      default: 0,
    },
    {
      attributeName: 'bandwidthModulationLateLoadFactor',
      helpText: 'If the player runs into late load issues it will become more conservative (should be >1).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Bandwidth Modulation Late Load Factor',
      placeholder: 'Input a bandwidth modulation late load factor...',
      default: 0,
    },
    {
      attributeName: 'bandwidthModulationRecoverFactor',
      helpText: 'The rate at which, if everything goes well, the player will return to normal (should be <1).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Bandwidth Modulation Recover Factor',
      placeholder: 'Input a bandwidth recover factor...',
      default: 0,
    },
    {
      attributeName: 'viewportChangeBandwidthFactor',
      helpText: 'The factor determining how much will the player let the bitrate decrease at a viewport change. A higher value makes the evaluator more conservative',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Viewport Change Bandwidth Factor',
      placeholder: 'Input a viewport change bandwidtch factor...',
      default: 0,
    },
    
    {
      attributeName: 'camChangeBandwidthFactor',
      helpText: 'The factor determining how much will the player let the bitrate decrease at a camera change. A higher value makes the evaluator more conservative.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Cam Change Bandwidth Factor',
      placeholder: 'Input a cam change bandwidth factor...',
      default: 0,
    },
    {
      attributeName: 'minDurationForCamChange',
      helpText: '"Safety distance" top have to playback edge before considering a camera change (miliseconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Min Duration For Camera Change',
      placeholder: 'Input a Min Duration For Camera Change...',
      default: 0,
    },
    {
      attributeName: 'liveEdgeLatency',
      helpText: 'Live Edge latency: For live streams,how far behind the real temporal edge to start buffering for content (miliseconds)',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Live Edge Latency',
      placeholder: 'Input a Live Edge Latency...',
      default: 0,
    },
  ],
};
